/* ============================================
   BMU Global Animation System v2.0
   Lightweight IntersectionObserver-based reveals
   ============================================ */

(function () {
  'use strict';

  const BMUAnimations = {
    observer: null,
    prefersReducedMotion: false,

    init: function () {
      this.prefersReducedMotion = window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

      if (this.prefersReducedMotion) {
        this.showAllImmediately();
        return;
      }

      this.createObserver();
      this.observeElements();
      this.bindEvents();
    },

    createObserver: function () {
      const self = this;
      this.observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              self.animateElement(entry.target);
              self.observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.1,
          rootMargin: '0px 0px -40px 0px'
        }
      );
    },

    observeElements: function () {
      const elements = document.querySelectorAll('.bmu-reveal');
      elements.forEach(function (el) {
        this.observer.observe(el);
      }, this);
    },

    animateElement: function (el) {
      // Handle stagger via data-delay
      const delay = el.dataset.delay;
      if (delay) {
        setTimeout(function () {
          el.classList.add('visible');
        }, parseInt(delay, 10));
      } else {
        el.classList.add('visible');
      }
    },

    showAllImmediately: function () {
      const elements = document.querySelectorAll('.bmu-reveal');
      elements.forEach(function (el) {
        el.classList.add('visible');
      });
    },

    bindEvents: function () {
      // Re-observe dynamically added elements after section loads
      document.addEventListener('shopify:section:load', this.onSectionLoad.bind(this));

      // Handle drawer/cart open animations
      document.addEventListener('cart:open', this.onCartOpen.bind(this));
      document.addEventListener('drawer:open', this.onDrawerOpen.bind(this));
    },

    onSectionLoad: function () {
      // Small delay to let DOM settle
      setTimeout(function () {
        this.observeElements();
      }.bind(this), 100);
    },

    onCartOpen: function () {
      this.animateCartElements();
    },

    onDrawerOpen: function () {
      this.animateDrawerElements();
    },

    animateCartElements: function () {
      const cartItems = document.querySelectorAll('.cart-drawer .bmu-reveal');
      cartItems.forEach(function (el, index) {
        setTimeout(function () {
          el.classList.add('visible');
        }, index * 50);
      });
    },

    animateDrawerElements: function () {
      const drawerItems = document.querySelectorAll('.drawer .bmu-reveal');
      drawerItems.forEach(function (el, index) {
        setTimeout(function () {
          el.classList.add('visible');
        }, index * 50);
      });
    },

    // Utility: Add reveal class to children of a container
    revealChildren: function (containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) return;

      const children = container.querySelectorAll('h1, h2, h3, h4, p, img, .media, a, button');
      children.forEach(function (child) {
        if (!child.classList.contains('bmu-reveal')) {
          child.classList.add('bmu-reveal');
          this.observer.observe(child);
        }
      }, this);
    }
  };

  // Initialize when DOM is ready
  function init() {
    BMUAnimations.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose for manual control
  window.BMUAnimations = BMUAnimations;
})();
